interface Props { active?: boolean }
export function FoodIcon({ active }: Props) {
  const sw = active ? 2.4 : 1.7;
  return (
    <svg width={26} height={26} viewBox="0 0 26 26" fill="none">
      <path
        d="M6 4v8a3 3 0 003 3v7M9 4v6M19 4c-1.5 0-3 2-3 5s1 4 3 4v9"
        stroke="currentColor"
        strokeWidth={sw}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
